import * as server from '../entries/pages/friends/_id_/_page.server.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/friends/_id_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/friends/[id]/+page.server.js";
export const imports = ["_app/immutable/nodes/5.0EErumtA.js","_app/immutable/chunks/scheduler.11LYO-93.js","_app/immutable/chunks/index.v-pHvQc9.js","_app/immutable/chunks/PlainText.YbcX27Nq.js","_app/immutable/chunks/preload-helper.0HuHagjb.js"];
export const stylesheets = ["_app/immutable/assets/PlainTextEditor.xHEe33NN.css"];
export const fonts = [];
